export function formatDate(isoDate: string | null): string {
  if (!isoDate) return '\u2014'
  try {
    return new Date(isoDate).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  } catch {
    return isoDate
  }
}
